
















































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { PropType } from 'vue';
import { OrderRec, TreeItem } from '@/interfaces';
import DocumentMixin from '@/mixins/DocumentMixin';

@Component
export default class DraggableTreeviewNode extends Mixins(DocumentMixin) {
  @Prop() public readonly rec!: OrderRec;
  @Prop({
    type: Object as PropType<TreeItem>,
    default: (): TreeItem => ({
      id: '0',
      name: '',
      children: []
    })
  })
  public value!: TreeItem;
  @Prop({ type: Number, default: 0 }) public level;
  @Prop({ type: Boolean, default: false }) public root;
  @Prop({ type: String, default: null }) public group;
  @Prop({ type: String }) public expandIcon;
  @Prop({ type: Boolean }) public isReadOnly;
  @Prop({ type: Array }) public active;
  @Prop({ type: Number }) public version;

  public open = true;
  public localValue = { ...this.value } as TreeItem;

  public get hasChildren() {
    return this.value.children != null && this.value.children.length > 0;
  }

  public get isDark() {
    return false;
  }

  public get appendLevel() {
    return this.level + (this.hasChildren ? 0 : 1);
  }

  public getHideFromCustomer(value) {
    const item = this.getItem(value.id, this.rec);
    if (!item) {
      return '';
    } else {
      return item.hide_from_customer;
    }
  }

  public getLabel(value) {
    const item = this.getItem(value.id, this.rec);
    if (this.isGroup(value.id)) {
      return item.description;
    } else {
      if (!item) {
        return '';
      } else {
        const unittypes = this.getCachedChoice('unittypes-choice');
        const quantity = item.quantity ? item.quantity : '';
        let unittype: any = '';
        const description = item.description ? item.description : '';
        if (unittypes) {
          const rec: any = unittypes.records.find(
            u => u.value === item.unittype_id
          );
          unittype = rec && !rec.fixed_amount ? rec.text : '';
        }
        return quantity + ' ' + unittype + ' ' + description;
      }
    }
  }

  public getAmount(value) {
    const item = this.getItem(value.id, this.rec);
    const amount = (this.$options as any).filters.euro(item.amount_exclusive);
    if (item.is_option) {
      return '(' + amount + ')';
    }
    return amount;
  }

  public selectItem() {
    this.setSelectedItem(this.value.id);
  }

  public openItem() {
    this.open = !this.open;
  }

  public updateValue(value: TreeItem[]): void {
    this.localValue.children = [...value];
    this.$emit('input', this.localValue);
  }

  public updateChildValue(value: TreeItem): void {
    const index = this.localValue.children.findIndex(c => c.id === value.id);
    this.$set(this.localValue.children, index, value);
    this.$emit('input', this.localValue);
  }

  @Watch('value') public valueChangedChanged(
    value: TreeItem,
    oldValue: TreeItem
  ) {
    this.localValue = { ...value };
  }
}
